import * as React from 'react'
import './eataly_styles_christmas.scss'
import TSConstants from '../../utils/TSConstants'
import { FunctionComponent } from 'react'

interface Props {
  text: string
  smallTopContainer: boolean
  displaySnowflakesForSubtitle: boolean
}

const EatalyLogoContainer: FunctionComponent<Props> = (props) => {
  return (
    <div
      className={
        props.smallTopContainer
          ? 'eat-top-container-small'
          : 'eat-top-container'
      }
    >
      <div
        style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 80 }}
      >
        <img
          src={eatalySnowflake}
          className="eat-sf-top-left"
          alt={'snowflake'}
        />
        <img
          src={eatalySnowflake}
          className="eat-sf-right_1"
          alt={'snowflake'}
        />
        <img
          src={eatalySnowflake}
          className="eat-sf-right-2"
          alt={'snowflake'}
        />
      </div>

      <div className="eat-title-container">
        <img
          className="eat-title-sf twic"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/img/christmas/snowflake_white.png`}
          alt={'snowflake'}
        />
        <h1 className="text-center eat-title">
          Un Noël
          <br />
          ALL'ITALIANA
        </h1>
      </div>

      <div className="text-center cm-pad eat-subtitle-container">
        {props.displaySnowflakesForSubtitle && (
          <img src={eatalySnowflake} className="eat-st-img" alt={'snowflake'} />
        )}
        <span className="eat-subtitle">{props.text}</span>
        {props.displaySnowflakesForSubtitle && (
          <img src={eatalySnowflake} className="eat-st-img" alt={'snowflake'} />
        )}
      </div>
    </div>
  )
}

export default EatalyLogoContainer

export const eatalySnowflake = require('./img/snowflake.png')
// export const eatalyWhiteSnowflake = require('./img/snowflake_white.png')
export const eatalySmallSnowflake = require('./img/small_snowflake.png')
